import * as React from 'react'
import { FC, ReactElement } from 'react'
import { ColorsType } from '../../utils/constants'
import * as styles from './Button.module.scss'

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  btnStyle: ColorsType
}

const Button: FC<IButtonProps> = (props: IButtonProps): ReactElement<IButtonProps> => {
  const { btnStyle, children, className, ...rest } = props

  const classes = [styles.button, 'text--small', styles[btnStyle], className ? className : '']

  return (
    <button className={classes.join(' ')} {...rest}>
      {children}
    </button>
  )
}

export default Button
